module.exports = __webpack_public_path__ + "static/img/know_button.98297adc.png";